import { Pipe, PipeTransform } from "@angular/core";
import { AppReferentialResolverService } from "../../services/dictionary/app-referential-resolver.service";

@Pipe({
  name: "dictionary",
})
export class DictionaryPipe implements PipeTransform {
  constructor(private resolverService: AppReferentialResolverService) {}

  transform(key: any, keyClass: any): string {
    return this.resolverService.retrieveLabel(keyClass, key + "");
  }
}
